module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chief"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.chief.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.chief, "isHidden", $$v)
      },
      expression: "chief.isHidden"
    }
  }, [_vm._v("Скрыть сотрудника")])], 1), _vm._v(" "), _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteChief(_vm.chief.id)
      }
    }
  }), _vm._v(" "), (!_vm.chief.photo) ? _c('div', {
    staticClass: "load-photo-wrapper centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadChiefPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить фото\n      ")]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })]) : _c('div', {
    staticClass: "photo-container",
    style: (_vm.photoStyle)
  }, [_c('a', {
    staticClass: "button is-danger delete-photo",
    on: {
      "click": function($event) {
        return _vm.deleteChiefPhoto(_vm.chief.id)
      }
    }
  }, [_vm._v("Удалить фото")])]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Имя"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.chief.name),
      callback: function($$v) {
        _vm.$set(_vm.chief, "name", $$v)
      },
      expression: "chief.name"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Должность"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.chief.position),
      callback: function($$v) {
        _vm.$set(_vm.chief, "position", $$v)
      },
      expression: "chief.position"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Цитата",
      "type": "textarea"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.chief.citation),
      callback: function($$v) {
        _vm.$set(_vm.chief, "citation", $$v)
      },
      expression: "chief.citation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSave()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1970761f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/DepartmentChief.vue
// module id = 902
// module chunks = 0